import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Button } from "react-bootstrap";
import Select from "react-select";
import { selectStyles } from "../helper/SelectStyles";
import { useNavigate } from "react-router-dom";
import TablePagination from "./TablePagination";

const PastParticipantsLayer = () => {
    const navigate = useNavigate();
    const [expoOptions, setExpoOptions] = useState([
        { value: "expo1", label: "Global Trade Fair 2026" },
        { value: "expo2", label: "Tech Expo 2026" },
    ]);
    const [selectedExpo, setSelectedExpo] = useState(null);
    const [data, setData] = useState([
        { _id: "1", expoName: "Global Trade Fair 2025", expoDate: "2025-05-10", companyName: "Innovate Inc", bookingAmount: "50000", stallNo: "A12", area: "12sq.m", remarks: "Full payment done", rate: "4000", eventManager: "Admin User" },
        { _id: "2", expoName: "Tech Expo 2025", expoDate: "2025-06-15", companyName: "Global Logistics", bookingAmount: "35000", stallNo: "B05", area: "9sq.m", remarks: "N/A", rate: "3800", eventManager: "Admin User" }
    ]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(2);

    const handleSubmit = () => {
        setLoading(true);
        setTimeout(() => setLoading(false), 500);
    };

    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-header border-bottom py-12 px-24 d-flex align-items-center justify-content-between" style={{ background: "linear-gradient(135deg, #000000ff, #bb0007ff, #ff0000ff)" }}>
                <h6 className="text-white pb-2 mb-0">Past Participants</h6>
                {/* <button
                    onClick={() => navigate(-1)}
                    className="btn btn-sm d-flex align-items-center gap-2 text-white"
                    style={{ backgroundColor: "rgba(255,255,255,0.2)", border: "1px solid white" }}
                >
                    <Icon icon="solar:alt-arrow-left-bold" />
                    Back
                </button> */}
            </div>
            <div className="card-body p-24">
                <div className="d-flex align-items-center gap-3 mb-24 p-16 radius-8" style={{ border: "1px solid #f7e7da" }}>
                    <label className="fw-bold mb-0">Expo Name :</label>
                    <div style={{ width: "300px" }}>
                        <Select
                            options={expoOptions}
                            value={selectedExpo}
                            onChange={setSelectedExpo}
                            styles={selectStyles()}
                            placeholder="-- Select --"
                        />
                    </div>
                    <button
                        className="btn px-24 py-8"
                        onClick={handleSubmit}
                        style={{ backgroundColor: "#e9ecef", border: "1px solid #ced4da", color: "black" }}
                    >
                        Submit
                    </button>
                </div>

                <div className="table-responsive">
                    <table className="table bordered-table sm-table mb-0">
                        <thead>
                            <tr style={{ backgroundColor: "#f7e7da" }}>
                                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>S.No</th>
                                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Expo name</th>
                                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Expo date</th>
                                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Company Name</th>
                                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Booking amount</th>
                                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Stall No</th>
                                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Booking area</th>
                                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Booking remarks</th>
                                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Rate per sq. meter</th>
                                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Event Manager</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.length > 0 ? (
                                data.map((item, index) => (
                                    <tr key={item._id || index}>
                                        <td>{currentPage * rowsPerPage + index + 1}</td>
                                        <td>{item.expoName}</td>
                                        <td>{item.expoDate}</td>
                                        <td>{item.companyName}</td>
                                        <td>₹{item.bookingAmount}</td>
                                        <td>{item.stallNo}</td>
                                        <td>{item.area}</td>
                                        <td>{item.remarks}</td>
                                        <td>₹{item.rate}</td>
                                        <td>{item.eventManager}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr><td colSpan="10" className="text-center py-4">No data available in table</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <TablePagination
                    currentPage={currentPage}
                    totalPages={Math.ceil(totalRecords / rowsPerPage)}
                    onPageChange={setCurrentPage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={(e) => setRowsPerPage(parseInt(e.target.value))}
                    totalRecords={totalRecords}
                />
            </div>
        </div>
    );
};

export default PastParticipantsLayer;
